<template>
  <div class="row" style="border-left: 0px solid">
    <div class="col-12 col-md-12 col-lg-12" style="color: black;">
      {{ name }}
    </div>
    <div class="col-12 col-md-12 col-lg-12" style="color: black;">
      {{ title }} <i v-if="contact.linkedin" class="fa fa-linkedin-square"></i>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";

export default {
  name: "ContactCard",
  props: ["contact"],
  computed: {
    name: function() {
      var contentString = this.contact.name ? `${this.contact.name},` : ``;
      return contentString;
    },
    title: function() {
      var contentString = this.contact.title ? `${this.contact.title}` : ``;
      return contentString;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/elements/ProviderContactCard.vue